<template>
  <div>
    <div v-if="gates && gates.length">
      <p v-for="(gate, index) in gates" :key="index">
        <brake-listing-table
          :key="index"
          :title="gate.gateName"
          :data="gate.data"
        />
      </p>
    </div>
    <p class="top-margin subtitle is-5">
      Ukupno vrijeme na pauzi: <b>{{ totalValueFormated }}</b>
    </p>
  </div>
</template>

<script>
import BrakeListingTable from "./BrakeListingTable.vue";
import { getDateFromTicks } from "../../_helpers/arrangers";

export default {
  name: "BrakeListing",

  props: {
    insideEvents: Array,
  },

  components: {
    BrakeListingTable,
  },

  data() {
    return {
      gates: [],
      totalValue: 0,
      totalValueFormated: "",
    };
  },

  mounted() {
    this.gates = this.$store.state.general.checkpointsOfInsideGates;

    console.log(this.gates);

    for (let i = 0; i < this.gates.length; i++) {
      this.gates[i].data = [];
    }

    this.insideEvents.forEach((ie) => {
      if (ie.isLogicallyClosed) {
        this.gates.forEach((gate) => {
          if (ie.value === gate.checkpointId) {
            gate.data.push(ie);
            this.totalValue += ie.duration;
          }
        });
      }
    });

    this.totalValueFormated = getDateFromTicks(this.totalValue);
  },
};
</script>

<style scoped>
.top-margin {
  margin-top: 10px; /* Adjust this value as needed */
}
</style>